import { t } from "i18next";
import { DataTableData } from "../../../../../components/deprecated/DataTable/DataTable";
import { PopupTemplates } from "../../../../../components/deprecated/PopupTemplates/PopupTemplates";

import { ToastUtilities } from "../../../../../libs/react-toastify/ToastUtilities";
import BookingUnitData from "../../../Property/Booking/BookingUnitData";
import { PropertyData } from "../../../Property/PropertyData";
import { Role } from "../../../User/Role";
import {
  FirebaseDataBookingGroupingField,
  FirebaseDataBookingUnitField,
  FirebaseDataCalendarViewField,
} from "../../DataObjectField/CustomFields/BookingUnitFields";
import { FirebaseDataPropertyField } from "../../DataObjectField/CustomFields/FirebaseDataPropertyField";
import { DataObjectField } from "../../DataObjectField/DataObjectField";
import { FirebaseDataBooleanField } from "../../DataObjectField/Generic/FirebaseDataBooleanField";
import { FirebaseDataNumberField } from "../../DataObjectField/Generic/FirebaseDataNumberField";
import { FirebaseDataStringField } from "../../DataObjectField/Generic/FirebaseDataStringField";
import { DataObjectAction, DataObjectHelper } from "../../DataObjects/DataObjectHelper";
import { LocalData } from "../../LocalData";

export class BookingUnitDataHelper extends DataObjectHelper<BookingUnitData> {
  id = () => "bookingUnit";

  property = new FirebaseDataPropertyField<BookingUnitData>(
    "property",
    t("main.property"),
    (bookingUnit) => (bookingUnit.parent instanceof PropertyData ? bookingUnit.parent : undefined),
    "business"
  );
  name = new FirebaseDataStringField<BookingUnitData>("name", t("main.name"), (bookingUnit) => bookingUnit.name, "abc");
  titleDisabled = new FirebaseDataBooleanField<BookingUnitData>(
    "titleDisabled",
    t("main.titleDisabled"),
    (bookingUnit) => bookingUnit.titleDisabled,
    "gavel"
  );
  emailRequired = new FirebaseDataBooleanField<BookingUnitData>(
    "emailRequired",
    t("main.emailRequired"),
    (bookingUnit) => bookingUnit.emailRequired,
    "mail"
  );
  phoneRequired = new FirebaseDataBooleanField<BookingUnitData>(
    "phoneRequired",
    t("main.phoneRequired"),
    (bookingUnit) => bookingUnit.phoneRequired,
    "phone"
  );
  nameRequired = new FirebaseDataBooleanField<BookingUnitData>(
    "nameRequired",
    t("main.nameRequired"),
    (bookingUnit) => bookingUnit.nameRequired,
    "person"
  );
  verificationText = new FirebaseDataStringField<BookingUnitData>(
    "verificationText",
    t("main.verificationText"),
    (bookingUnit) => bookingUnit.verificationText,
    "verified_user"
  );
  verifiedBookingText = new FirebaseDataStringField<BookingUnitData>(
    "verifiedBookingText",
    t("main.verifiedBookingTextDescription"),
    (bookingUnit) => bookingUnit.verifiedBookingText,
    "verified_user"
  );
  verifiedBookingTextDigitalKeys = new FirebaseDataStringField<BookingUnitData>(
    "verifiedBookingTextDigitalKeys",
    t("main.verifiedBookingTextDigitalKeysDescription"),
    (bookingUnit) => bookingUnit.verifiedBookingTextDigitalKeys,
    "verified_user"
  );
  //dateRange
  emailVerificationReceivers = new FirebaseDataStringField<BookingUnitData>(
    "emailVerificationReceivers",
    t("main.sendEmailNotification"),
    (bookingUnit) => bookingUnit.emailVerificationReceivers,
    "gavel",
    true
  );
  calendarColor = new FirebaseDataStringField<BookingUnitData>(
    "calendarColor",
    t("main.calendarColor"),
    (bookingUnit) => bookingUnit.calendarColor,
    "palette"
  );
  defaultCalendarView = new FirebaseDataCalendarViewField<BookingUnitData>(
    "defaultCalendarView",
    t("main.defaultCalendarView"),
    (bookingUnit) => bookingUnit.defaultCalendarView,
    "calendar_today"
  );
  // digitalLocks
  digitalKeyStartBufferTime = new FirebaseDataNumberField<BookingUnitData>(
    "digitalKeyStartBufferTime",
    t("main.digitalKeyStartBufferTime"),
    (bookingUnit) => bookingUnit.digitalKeyStartBufferTime,
    "access_time"
  );
  digitalKeyEndBufferTime = new FirebaseDataNumberField<BookingUnitData>(
    "digitalKeyEndBufferTime",
    t("main.digitalKeyEndBufferTime"),
    (bookingUnit) => bookingUnit.digitalKeyEndBufferTime,
    "access_time"
  );
  maxUnlocKeys = new FirebaseDataNumberField<BookingUnitData>(
    "maxUnlocKeys",
    t("main.maxUnlocKeys"),
    (bookingUnit) => bookingUnit.maxUnlocKeys,
    "lock"
  );
  allowOverlappingEvents = new FirebaseDataBooleanField<BookingUnitData>(
    "allowOverlappingEvents",
    t("main.allowOverlappingEvents"),
    (bookingUnit) => bookingUnit.allowOverlappingEvents,
    "gavel"
  );
  minBookingDuration = new FirebaseDataNumberField<BookingUnitData>(
    "minBookingDuration",
    t("main.minBookingDuration"),
    (bookingUnit) => bookingUnit.minBookingDuration,
    "access_time"
  );
  maxBookingDuration = new FirebaseDataNumberField<BookingUnitData>(
    "maxBookingDuration",
    t("main.maxBookingDuration"),
    (bookingUnit) => bookingUnit.maxBookingDuration,
    "access_time"
  );
  minTimeToStart = new FirebaseDataNumberField<BookingUnitData>(
    "minTimeToStart",
    t("main.minTimeToStart"),
    (bookingUnit) => bookingUnit.minTimeToStart,
    "access_time"
  );
  maxTimeToStart = new FirebaseDataNumberField<BookingUnitData>(
    "maxTimeToStart",
    t("main.maxTimeToStart"),
    (bookingUnit) => bookingUnit.maxTimeToStart,
    "access_time"
  );
  minTimeBetweenAllEvents = new FirebaseDataNumberField<BookingUnitData>(
    "minTimeBetweenAllEvents",
    t("main.minTimeBetweenAllEvents"),
    (bookingUnit) => bookingUnit.minTimeBetweenAllEvents,
    "access_time"
  );
  minTimeBetweenGroupEvents = new FirebaseDataNumberField<BookingUnitData>(
    "minTimeBetweenGroupEvents",
    t("main.minTimeBetweenGroupEvents"),
    (bookingUnit) => bookingUnit.minTimeBetweenGroupEvents,
    "access_time"
  );
  minPeriodBeforeCancellation = new FirebaseDataNumberField<BookingUnitData>(
    "minPeriodBeforeCancellation",
    t("main.minPeriodBeforeCancellation"),
    (bookingUnit) => bookingUnit.minPeriodBeforeCancellation,
    "access_time"
  );
  bookingGrouping = new FirebaseDataBookingGroupingField<BookingUnitData>(
    "bookingGrouping",
    t("main.groupSettings"),
    (bookingUnit) => bookingUnit.bookingGrouping,
    "group"
  );
  disabledParallelBookingUnits = new FirebaseDataBookingUnitField<BookingUnitData>(
    "disabledParallelBookingUnits",
    t("main.disableParallelBookingForUnits"),
    (bookingUnit) => bookingUnit.disabledParallelBookingUnits,
    "group",
    true
  );

  allFields(): DataObjectField<any, BookingUnitData>[] {
    return [
      this.property,
      this.name,
      this.titleDisabled,
      this.emailRequired,
      this.phoneRequired,
      this.nameRequired,
      this.verificationText,
      this.verifiedBookingText,
      this.verifiedBookingTextDigitalKeys,
      this.emailVerificationReceivers,
      this.calendarColor,
      this.defaultCalendarView,
      this.digitalKeyStartBufferTime,
      this.digitalKeyEndBufferTime,
      this.maxUnlocKeys,
      this.allowOverlappingEvents,
      this.minBookingDuration,
      this.maxBookingDuration,
      this.minTimeToStart,
      this.maxTimeToStart,
      this.minTimeBetweenAllEvents,
      this.minTimeBetweenGroupEvents,
      this.minPeriodBeforeCancellation,
      this.bookingGrouping,
      this.disabledParallelBookingUnits,
    ];
  }

  override displayName(): string {
    return t("main.bookingUnit");
  }
  override displayNamePlural(): string {
    return t("main.bookingUnits");
  }

  override getAllDatas(): BookingUnitData[] {
    const bookingUnits: BookingUnitData[] = [];
    for (const property of LocalData.currentUser.properties) {
      for (const bookingUnit of property.bookingUnits.documents) {
        bookingUnits.push(bookingUnit);
      }
    }
    return bookingUnits;
  }

  loadAll(): Promise<any> {
    const allPromises: Promise<any>[] = [];

    let properties: PropertyData[] = LocalData.currentUser.properties;

    for (const property of properties) {
      const promise = new Promise<BookingUnitData[]>((resolve) => {
        property.bookingUnits.load((bookingUnits) => {
          resolve(bookingUnits);
        });
      });
      allPromises.push(promise);
    }
    return Promise.all(allPromises);
  }

  getAllDataTableDatas(documents: BookingUnitData[]): DataTableData[] {
    return documents.map((data) => {
      const property = data.parent instanceof PropertyData ? data.parent : undefined;
      return {
        key: data.id,
        cells: {
          name: data.name,
          property: property?.name,
        },
      };
    });
  }

  getLinkTo(key: string): string | undefined {
    const bookingUnit = LocalData.currentUser.properties.flatMap((p) => p.bookingUnits.documents).find((u) => u.id === key);
    if (bookingUnit && bookingUnit.parent && bookingUnit.parent.id && bookingUnit.id) {
      return "/properties/" + bookingUnit.parent.id + "/bookingUnits/" + key;
    }
    return undefined;
  }
  override getDefaultFilterFields = (): DataObjectField<any, any>[] => {
    return [this.name, this.property];
  };

  override getActionsForData = (data: BookingUnitData): DataObjectAction<BookingUnitData>[] => {
    const actions: DataObjectAction<BookingUnitData>[] = [];
    const property = data.parent instanceof PropertyData ? data.parent : undefined;
    const member = property?.members.getData(LocalData.currentUser.id);
    if (member?.isAdmin && member.roles.includes(Role.LANDLORD)) {
      actions.push({
        id: "delete",
        iconName: "delete",
        title: t("main.delete") + " " + t("main.bookingUnit").toLowerCase(),
        requiredConsent: (dataObjects) => {
          return new Promise((resolve) => {
            PopupTemplates.presentVerifyDeleteDatas(
              this,
              dataObjects.map((data) => data.name),
              () => {
                resolve({ dataObjects });
              }
            );
          });
        },
        performAction: () => {
          return ToastUtilities.presentPromise(t("main.deleting"), data.deleteDocument());
        },
      });
    }
    return actions;
  };
}

